import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import type { BaseAnswerType } from '../../../../../../../chat/views/types';
import type { BuildingTypeButtonGroupPropsType } from '../..';

const { tablet, mobile } = mediaQueries();

type BuildingTypeAnswerCheckboxLikeButtonPropsType = Merge<BuildingTypeButtonGroupPropsType & Required<BaseAnswerType> & {
  isAnswered: boolean;
  onClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
}>;

export const BuildingTypeAnswerCheckboxLikeButton = ({
  id,
  value,
  textContents,
  gaEventName,
  isAnswered,
  onClickHandler: onClickHandlerFromProps,
  answers,
}: BuildingTypeAnswerCheckboxLikeButtonPropsType) => {
  const [isActive, setIsActive] = React.useState<boolean>(null);
  const onClickHandler = React.useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    // ボタンをアクティブに変更
    setIsActive(true);

    // ボタンのクリックイベントを実行
    onClickHandlerFromProps(event);
  }, [onClickHandlerFromProps]);

  return (
    <div
      css={css`
        padding: 0 0 4px;
        position: relative;
      `}
    >
      <button
        type="button"
        id={`ga_event_${gaEventName}_${id}`}
        value={value}
        onClick={onClickHandler}
        css={css`
          color: #212b60;
          font-size: 16px;
          font-weight: bold;
          text-align: center;
          display: flex;
          align-items: center;
          height: 48px;
          padding-left: 40px;
          padding-right: 1rem;
          background-color: #fff;
          border: 2px solid #041156;
          border-radius: 10px;
          box-shadow: 0 4px 0 #545971;
          position: relative;

          ${mobile(({ clamp }) => css`
            font-size: ${clamp('11px', '14px')};
          `)}

          &:hover {
            opacity: 0.7;
          }

          &::before,
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }

          &::before {
            width: 22px;
            height: 22px;
            background-color: #fff;
            border: 2px solid #041156;
            border-radius: 50%;
            left: 11px;
          }

          &::after {
            display: none;
            width: 10px;
            height: 10px;
            background-color: #ffd803;
            border-radius: 50%;
            left: 17px;

            ${isActive !== null && isActive && css`
              display: block;
            `}
          }

          ${isActive !== null && isActive && css`
            background-color: #fff7c9;
            box-shadow: none;
            opacity: 1;
          `}

          ${isAnswered && css`
            pointer-events: none;
          `}
        `}
      >
        {textContents}
      </button>
    </div>
  );
};
